/* eslint-disable jsx-a11y/anchor-is-valid */
import TextField from "../../../../../components/textFields/TextField"
import { useGetApproversPolicyModeLookupQuery } from "../../../../../services/GeneralApi"
import labelKey from "../../../../localization/label.json"
import ReactInputMask from "react-input-mask"

type Props = {
  formik: any
}
const Step1 = ({ formik, }: Props) => {
  const { data: approvalpolicy } = useGetApproversPolicyModeLookupQuery('')
  return (
     <div className="row current overflow-auto" data-kt-stepper-element='content'>
           <div className="col-12 mb-4">
             {/* Organisation Details Card */}
             <div className="card border-0 shadow-sm bg-light rounded-3 mb-4">
               <div className="card-body p-4 p-md-5">
                 <div className="mb-5">
                   <h3 className="fw-bold fs-4 mb-0 text-dark">Organisation Details</h3>
                 </div>
                 <div className='w-100 row g-4'>
                   <div className='col-12'>
                     <TextField
                       label={labelKey.organizationName}
                       required={true}
                       type="text"
                       placeholder='Enter Organization Name'
                       {...formik.getFieldProps('legalName')}
                     />
                   </div>
                   <div className='col-12'>
                     <TextField
                       label={labelKey.addressLine1}
                       placeholder='Enter Address'
                       type="text"
                       {...formik.getFieldProps('legalAddrLine1')}
                     />
                   </div>
                   <div className='col-12'>
                     <TextField
                       label={labelKey.addressLine2}
                       placeholder='Enter Address'
                       type="text"
                       {...formik.getFieldProps('legalAddrLine2')}
                     />
                   </div>
                   <div className='col-4'>
                     <TextField
                       label={labelKey.city}
                       placeholder='Enter City'
                       type="text"
                       {...formik.getFieldProps('legalCity')}
                     />
                   </div>
                   <div className='col-4'>
                     <TextField
                       label={labelKey.state}
                       placeholder='Enter State'
                       type="text"
                       {...formik.getFieldProps('legalState')}
                     />
                   </div>
                   <div className='col-4'>
                     <TextField
                       label={labelKey.zipCode}
                       placeholder='Enter Zip Code'
                       type="text"
                       {...formik.getFieldProps('legalZip')}
                     />
                   </div>
                 </div>
               </div>
             </div>
           </div>
           <div className="col-12 mt-3">
             {/* Contact Person Details Card */}
             <div className="card border-0 shadow-sm bg-light rounded-3">
               <div className="card-body p-4 p-md-5">
                 <div className="mb-5">
                   <h3 className="fw-bold fs-4 mb-0 text-dark">Contact Person Details</h3>
                 </div>
                 <div className='w-100 row g-4'>
                   <div className='col-12'>
                     <TextField
                       label={labelKey.personName}
                       placeholder='Enter Person Name'
                       type="text"
                       {...formik.getFieldProps('contactPersonName')}
                     />
                   </div>
                   <div className='col-6'>
                     <TextField
                       label={labelKey.personEmail}
                       required={true}
                       type="email"
                       className='form-control form-control-lg form-control-solid default-input'
                       {...formik.getFieldProps('contactPersonEmail')}
                       placeholder='Enter Email'
                     />
                   </div>
                   <div className='col-6'>
                     <label className='form-label fs-5 fw-bold'>{labelKey.contactNo}</label>
                     <ReactInputMask
                       mask="999-999-9999"
                       maskChar=""
                       type="text"
                       className="form-control form-control-lg form-control-solid default-input"
                       placeholder="Enter Contact No"
                       {...formik.getFieldProps('contactPersonMobile')}
                     />
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </div>
  )
}

export { Step1 };

